import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { useConnectivityStore } from '@shared/hooks/useConnectivityStore';
import IconButtonTooltip from './IconButtonTooltip';

const stateConfig = {
  online: { color: 'success.main', label: 'Online' },
  offline: { color: 'grey.500', label: 'Offline (read-only)' },
  disconnected: { color: 'error.main', label: 'Disconnected' },
} as const;

/** Connectivity indicator dot: green/gray/red based on state. */
export default function ConnectivityDot() {
  const state = useConnectivityStore((s) => s.state);
  const config = stateConfig[state];

  return (
    <IconButtonTooltip title={config.label} size="small">
      <FiberManualRecordIcon sx={{ fontSize: 12, color: config.color }} />
    </IconButtonTooltip>
  );
}
